import {createDeleteRequest,  makeRequest} from "../utils/apiUtil";

export function deleteResource(id) {
    return makeRequest(createDeleteRequest('resource/' + id));
}